// extracted by mini-css-extract-plugin
module.exports =  {"nameSummaryContainer":"style-module_nameSummaryContainer__ic69LXGfTDmSahicOapI","nameSummary":"style-module_nameSummary__hkWQmWAgAGsu7n1CihA0"};